module.exports = __webpack_public_path__ + "img/25.54bb145c.svg";